module.exports = __webpack_public_path__ + "img/9788957983508.17fa4459.jpg";